import { OrderTargetBreakdownRow, ToOrderTargetBreakdownRowsParams } from './orderTargets.types';

export const toOrderTargetBreakdownRows = ({
  items,
  calculatedAt,
}: ToOrderTargetBreakdownRowsParams): OrderTargetBreakdownRow[] =>
  items.map((item) => ({
    id: item.id,
    label: item.label,
    attainedValue: item.attained,
    plannedValue: item.plannedValue,
    attainment: {
      attainedByStatus: item.attainedByStatus,
      conversion: item.conversion,
      calculatedAt,
    },
  }));
